// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 984) return "static/chunks/984-fa7cc2547123f978.js";
	if (chunkId === 5186) return "static/chunks/5186-0436976de7eecac8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4226":"f6ba9c5a105da601","6486":"7f5719d501b2a8b1"}[chunkId] + ".js";
};